import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from './plugins'
import DropDown from './components/DropDown.vue'
import store from '@/store'

import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/scss/bootstrap.scss'
import 'primeicons/primeicons.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import '@/assets/styles/fontawesome.scss'
import '@/assets/styles/theme.scss'
import '@/assets/styles/flags.css'

(async () => {
    store.state.auth.token && await store.dispatch('auth/refreshToken')
    
    const app = createApp(App)
    registerPlugins(app)
    app.component('DropDown', DropDown)
    app.directive('focus', {
        mounted(el) {
            el.focus()
        }
    })
    app.directive('disable-floating-transition-load', {
        mounted(el) {
            el.classList.add('no-transition')
            requestAnimationFrame(() => {
                // Espera hasta el próximo ciclo de renderizado y quita la clase
                el.classList.remove('no-transition')
            })
        }
    })
    app.mount('#app')
})()